import React from 'react';
import { Route } from 'library/util/core-router';
import { RouterComponents } from 'apps/admin/components/tools-dropdown/admin-tool-links';

const AdminToolRoutes = () =>
  Object.keys(RouterComponents).map((path) => {
    return <Route key={path} path={path} component={RouterComponents[path]} />;
  });

export default AdminToolRoutes;
